import "core-js/modules/es.promise.js";
import { ApolloClient as ApolloClientInstance, InMemoryCache, HttpLink, from } from '@apollo/client';
import { accessTokenItem } from "../auth";
import axios from 'axios';
import { authLink, errorLink, removeTypenameFromMutationLink } from "./links";
const httpLink = new HttpLink({
  uri: '/internal/graphql'
});
const links = [removeTypenameFromMutationLink, errorLink, authLink, httpLink];

// The fetch policy no-cache avoids using the apollo cache, this is a
// template so this is our default, but cache can be useful in some projects,
// more info: https://www.apollographql.com/docs/react/caching/cache-configuration/
const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore'
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all'
  }
};
export const ApolloClient = new ApolloClientInstance({
  link: from(links),
  cache: new InMemoryCache(),
  credentials: 'include',
  defaultOptions
});

// NOTE: keep sending credentials (cookies) in apollo and axios because of microfrontened compatibility
// Axios config

axios.defaults.withCredentials = true;
axios.interceptors.request.use(config => {
  var _config$url;
  if (!((_config$url = config.url) !== null && _config$url !== void 0 && _config$url.startsWith('/api/public'))) {
    const token = localStorage.getItem(accessTokenItem);
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
  }
  return config;
}, error => {
  return Promise.reject(error);
});